import { createIcon } from '../createIcon';
import { ReactComponent as IconHambuger } from '../svg/hambuger.svg';

export default createIcon(IconHambuger);
